import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/authcontext";
import { useFlash } from "../../context/flashcontext";
import api from "../../Api";
import AgendaView from "./AgendaView";
import { isOwnerOrFinance } from "../../utils/role-check";

function AgendaContainer() {
    const { auth } = useAuth();
    const { showFlash } = useFlash();
    const [projects, setProjects] = useState([]);
    const [assignments, setAssignments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchProjects = async () => {
        if (!auth) return;

        try {
            let projectsData;

            // Eigenaar and financieel medewerker see all projects
            // ZZPer and Voorman see only their assigned projects
            if (isOwnerOrFinance(auth.role)) {
                const response = await api.get("/projects");
                projectsData = response.data;
            } else {
                // Get projects for the current user
                const response = await api.get(`/users/${auth.userId}/projects`);
                projectsData = response.data;
            }

            setProjects(projectsData || []);
            setError(null);
        } catch (err) {
            console.error("Error fetching projects:", err);
            setError("Fout bij ophalen projecten");
        }
    };

    const fetchAssignments = async () => {
        if (!auth) return;

        try {
            // Get current month's date range
            const now = new Date();
            const startOfMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 2, 0);

            const startDate = startOfMonth.toISOString().split('T')[0];
            const endDate = endOfMonth.toISOString().split('T')[0];

            const response = await api.get(`/project-user-assignments?start_date=${startDate}&end_date=${endDate}`);
            setAssignments(response.data || []);
        } catch (err) {
            console.error("Error fetching assignments:", err);
            // Don't set error state, assignments are optional
        }
    };

    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            await Promise.all([fetchProjects(), fetchAssignments()]);
            setLoading(false);
        };

        loadData();
    }, [auth]);

    const handleAddAssignment = async (assignmentData) => {
        try {
            await api.post("/project-user-assignments", assignmentData);
            await fetchAssignments();
            showFlash("Toewijzing succesvol toegevoegd!", "success");
            return true;
        } catch (err) {
            console.error("Error adding assignment:", err);
            showFlash("Fout bij toevoegen toewijzing", "error");
            return false;
        }
    };

    const handleDeleteAssignment = async (assignmentId) => {
        try {
            await api.delete(`/project-user-assignments/${assignmentId}`);
            await fetchAssignments();
            showFlash("Toewijzing verwijderd!", "success");
        } catch (err) {
            console.error("Error deleting assignment:", err);
            showFlash("Fout bij verwijderen toewijzing", "error");
        }
    };

    return (
        <AgendaView
            projects={projects}
            assignments={assignments}
            loading={loading}
            error={error}
            auth={auth}
            onAddAssignment={handleAddAssignment}
            onDeleteAssignment={handleDeleteAssignment}
        />
    );
}

export default AgendaContainer;

